import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { SERVICES } from '../data/services';
import SectionHead from './SectionHead';
import MultilineText from './MultilineText';
import layout from '../styles/layout.module.css';
import styles from './ServicesSection.module.css';

const ServicesSection: React.FC = () => {
  const { elementRef, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section
      id="services"
      className={layout.section}
      aria-labelledby="services-title"
    >
      <div
        ref={elementRef}
        className={`${layout.wrap} ${layout.sectionInner} slide-up ${isVisible ? 'visible' : ''}`}
      >
        <SectionHead
          eyebrow="SERVICES"
          title="サービス"
          titleId="services-title"
          lead="AWS の設計・構築・移行、再販・請求代行、CI/CD、AI 開発ツール導入。技術顧問として月次で、あるいはスポットで、必要な範囲だけ支援します。"
        />

        <ul className={styles.list}>
          {SERVICES.map((service) => (
            <li key={service.id} className={styles.row}>
              <p className={styles.number}>{service.number}</p>
              <h3 className={styles.title}>
                <MultilineText text={service.title} />
              </h3>
              <p className={styles.description}>{service.description}</p>
              <p className={styles.tag}>{service.tag}</p>
            </li>
          ))}
        </ul>

        <div className={styles.footerRow}>
          <p className={styles.note}>
            月額顧問でも、スポットでも。関わり方は次の節で説明しています。
          </p>
          <a href="#engagement" className={layout.inlineLink}>
            関わり方を見る →
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
